import React from 'react'

import { Form, Row, Col, Portlet } from '_zari/core'

import * as Formatos from './formatos'

const ReporteCajaBancos = () => {
  const TIPOSREPORTE = {
    EFECTIVO: '1',
    CUENTA_CORRIENTE: '2'
  }

  const [tipoReporte, setTipoReporte] = React.useState(TIPOSREPORTE.EFECTIVO)

  return (
    <>
      <Portlet>
        <Portlet.Header title='Reporte Caja Bancos' />
        <Portlet.Body>
          <Row>
            <Col md={3}>
              <Form.Radio
                id='radio-efectivo'
                name='tipoReporte'
                label='Efectivo'
                value={TIPOSREPORTE.EFECTIVO}
                checked={tipoReporte === TIPOSREPORTE.EFECTIVO}
                onChange={() => setTipoReporte(TIPOSREPORTE.EFECTIVO)}
              />
              <Form.Radio
                id='radio-cuentaCorriente'
                name='tipoReporte'
                label='Cuenta Corriente'
                value={TIPOSREPORTE.CUENTA_CORRIENTE}
                checked={tipoReporte === TIPOSREPORTE.CUENTA_CORRIENTE}
                onChange={() => setTipoReporte(TIPOSREPORTE.CUENTA_CORRIENTE)}
              />
            </Col>
            <Col md={9} style={{ borderLeft: '1px solid black' }}>
              {tipoReporte === TIPOSREPORTE.EFECTIVO && <Formatos.FormatoEfectivo />}
              {tipoReporte === TIPOSREPORTE.CUENTA_CORRIENTE && <Formatos.FormatoCuentaCorriente />}
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(ReporteCajaBancos)
